package com.bulut.mecitogullari.core.i18n

val EnStrings = Strings(
    monthNames = listOf(
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ),
    monthNamesShort = listOf(
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ),
    categoryLabels = mapOf(
        "Daire Satışı" to "Unit Sale",
        "Kira Geliri" to "Rental Income",
        "Devir (Açılış Bakiyesi)" to "Carry-over (Opening Balance)",
        "Diğer Gelir" to "Other Income",
        "Malzeme" to "Materials",
        "İşçilik" to "Labor",
        "Taşeron" to "Subcontractor",
        "Arsa / Tapu" to "Land / Title Deed",
        "Vergi & Harç" to "Taxes & Fees",
        "Nakliye & Yakıt" to "Transport & Fuel",
        "Ofis / Genel" to "Office / General",
        "Ev Gideri" to "Household Expense",
        "Diğer Gider" to "Other Expense",
    ),
    values = mapOf(
        "income" to "Income",
        "expense" to "Expense",
        "netProfit" to "Net Profit",
        "total" to "Total",
        "date" to "Date",
        "description" to "Description",
        "category" to "Category",
        "project" to "Project",
        "amount" to "Amount",
        "cancel" to "Cancel",
        "save" to "Save",
        "add" to "Add",
        "delete" to "Delete",
        "back" to "Back",
        "ok" to "OK",
        "savedCheck" to "Saved ✓",
        "phoneOptional" to "Phone (optional)",
        "noteOptional" to "Note (optional)",
        "none" to "—",
        "loginTagline" to "Construction Management Platform",
        "loginHighlights" to "Monthly cashbook  •  Project expenses  •  Unit sales",
        "continueWithGoogle" to "Continue with Google",
        "continueAsGuest" to "Continue as guest",
        "loginFooter" to "Your data is stored securely in the cloud.\n" +
            "Guest data is tied to this device's session and cannot be recovered after sign-out.",
        "errorGoogleToken" to "Could not get Google sign-in credentials.",
        "errorSignInFailed" to "Sign-in failed.",
        "errorGuestFailed" to "Guest sign-in failed.",
        "guestName" to "Guest",
        "defaultUserName" to "User",
        "tabHome" to "Home",
        "tabTransactions" to "Transactions",
        "tabProjects" to "Projects",
        "tabReports" to "Reports",
        "tabProfile" to "Profile",
        "greeting" to "Hello",
        "cashSummaryTemplate" to "{month} cash summary",
        "netProfitTitle" to "Net Profit This Month",
        "closingBalanceLabel" to "Cash (End-of-Month Balance)",
        "statCarryOver" to "Carried Over",
        "statMonthIncome" to "Income",
        "statMonthExpense" to "Expenses",
        "recentTransactions" to "Recent Transactions",
        "seeAll" to "See All",
        "dashboardEmpty" to "No transactions this month yet.\nAdd your first income or expense with (+).",
        "addTransaction" to "Add transaction",
        "transactionsSearchHint" to "Search description or category",
        "tabAll" to "All",
        "noRecordsForMonth" to "No records found for {month}.",
        "noSearchMatch" to "No transactions match your search.",
        "shortcutDebtSubtitle" to "Suppliers & customers",
        "shortcutCraftsmenSubtitle" to "Work-for-unit barter",
        "excelMenu" to "Excel",
        "exportExcel" to "Export to Excel (.xlsx)",
        "importExcel" to "Import from Excel",
        "importExcelToProject" to "Import from Excel (into this project)",
        "downloadMonthPdf" to "Download month as PDF",
        "downloadPdf" to "Download as PDF",
        "previousMonth" to "Previous month",
        "nextMonth" to "Next month",
        "profileTitle" to "Profile",
        "statProjects" to "Projects",
        "statSoldUnits" to "Sold Units",
        "statMonthNet" to "Net This Month",
        "companySection" to "Company Info",
        "companyNameLabel" to "Company Name",
        "shortcutsSection" to "Shortcuts",
        "debtTracking" to "Debt Tracking",
        "debtTrackingSubtitle" to "Supplier accounts, purchases and payments",
        "craftsmenTitle" to "Craftsmen • Barter",
        "craftsmenSubtitle" to "Accounts of craftsmen paid with apartments",
        "languageSection" to "Language",
        "logout" to "Sign Out",
        "projectsEmpty" to "No projects yet.\nAdd your first site with \"New Project\".",
        "newProject" to "New Project",
        "statSales" to "Sales",
        "statNetIncome" to "Net Income",
        "reportsTitle" to "Monthly Report",
        "expenseBreakdown" to "Expense Breakdown",
        "incomeBreakdown" to "Income Breakdown",
        "noExpenseThisMonth" to "No expenses recorded this month.",
        "noIncomeThisMonth" to "No income recorded this month.",
        "cashNoteSection" to "Cash Handover Note",
        "cashNotePlaceholder" to "Notes about the end-of-month cash handover…",
        "saveNote" to "Save Note",
        "carryToNextMonth" to "Carried to Next Month",
        "openingBalanceLabel" to "Opening Balance",
        "debtLabel" to "Payable",
        "receivableLabel" to "Receivable",
        "closedLabel" to "Settled",
        "addCustomer" to "Add Customer",
        "addSupplier" to "Add Supplier",
        "debtsEmpty" to "No accounts yet.\nAdd a supplier (whom you buy from) or a customer " +
            "(whom you sell to) to track purchases, sales and payments.",
        "customer" to "Customer",
        "supplier" to "Supplier",
        "newCustomer" to "New Customer",
        "newSupplier" to "New Supplier",
        "customerAccountSubtitle" to "An account you sell materials to",
        "supplierAccountSubtitle" to "An account you buy materials from",
        "customerNameLabel" to "Customer Name",
        "firmNameLabel" to "Company Name",
        "addCraftsman" to "Add Craftsman",
        "craftsmenEmpty" to "No craftsmen yet.\nAdd craftsmen who work in exchange for apartments; " +
            "track their work, the units given and their balance here.",
        "craftsmanOwed" to "You owe",
        "craftsmanOwes" to "Owes you",
        "balanced" to "Settled",
        "workDone" to "Work done",
        "unitsGivenCount" to "{count} units given",
        "craftsman" to "Craftsman",
        "invoiceProgress" to "Invoiced: {invoiced} / {required}",
        "units" to "units",
        "newCraftsman" to "New Craftsman",
        "newCraftsmanIntro" to "A craftsman paid with apartments. The agreed amount of work and the " +
            "unit price drive the earned-value calculation.",
        "craftsmanNameLabel" to "Name (e.g. Electrician John)",
        "tradeLabel" to "Trade (Electrical, Plaster…)",
        "agreedWorkSection" to "Agreed Work (per apartment type)",
        "countLabel" to "Count",
        "pricePerUnitLabel" to "Price per unit",
        "requiredInvoiceLabel" to "Invoice Required (optional)",
        "requiredInvoiceHint" to "Total invoice amount you require from this craftsman. " +
            "Issued invoices are entered from the craftsman page via \"Entry → Invoice\".",
        "pdfMonthlyReport" to "Monthly Report",
        "pdfMonthlyReportSubtitle" to "Monthly Transaction Report",
        "pdfTransactionCount" to "{count} transactions",
        "pdfCarriedBalance" to "Opening Balance",
        "pdfTotalIncome" to "Total Income",
        "pdfTotalExpense" to "Total Expense",
        "pdfMonthlyNet" to "Monthly Net",
        "pdfClosingBalance" to "Closing Balance",
        "pdfProjectSummary" to "Project Summary",
        "pdfGeneralInfo" to "General Info",
        "pdfStartDate" to "Start",
        "pdfEstimatedEnd" to "Estimated End",
        "pdfBuilding" to "Building",
        "pdfBuildingTemplate" to "{floors} floors • {perFloor} units per floor",
        "pdfConstructionProgress" to "Construction Progress",
        "pdfCompletedStages" to "Completed Stages",
        "pdfNote" to "Note",
        "pdfUnitStatus" to "Unit Status",
        "pdfTotalUnits" to "Total Units",
        "pdfSold" to "Sold",
        "pdfReserved" to "Reserved",
        "pdfAvailable" to "Available",
        "pdfSalesTotal" to "Sales Total",
        "pdfSoldUnits" to "Sold Units",
        "pdfUnit" to "Unit",
        "pdfBuyer" to "Buyer",
        "pdfPrice" to "Price",
        "pdfPaid" to "Paid",
        "pdfRemaining" to "Remaining",
        "pdfBarterSuffix" to "barter",
        "pdfProjectTransactions" to "Project Transactions",
        "pdfNet" to "Net",
        "pdfCraftsmanStatement" to "Craftsman Account Statement",
        "pdfCraftsmenOverview" to "Craftsmen — Barter Account Summary",
        "pdfCraftsmanCount" to "{count} craftsmen",
        "pdfTrade" to "Trade",
        "pdfDoneAgreed" to "Done / Agreed",
        "pdfCurrentStatus" to "Current Status",
        "pdfWhenFinished" to "When Finished",
        "pdfRemainingInvoice" to "Invoice Left",
        "pdfAgreedWork" to "Agreed Work",
        "pdfUnitType" to "Unit Type",
        "pdfAgreed" to "Agreed",
        "pdfDone" to "Done",
        "pdfUnitPrice" to "Unit Price",
        "pdfAgreedValue" to "Agreed Value",
        "pdfEarned" to "Earned",
        "pdfGivenUnits" to "Units Given (barter)",
        "pdfInvoiceStatus" to "Invoice Status",
        "pdfRequiredInvoice" to "Invoice required",
        "pdfIssuedInvoice" to "Invoice issued",
        "pdfRemainingInvoiceLong" to "Still to be invoiced",
        "pdfAccountEntries" to "Account Entries",
        "pdfType" to "Type",
        "pdfExtraWork" to "Extra work/material",
        "pdfCashPayment" to "Cash payment",
        "pdfIssuedInvoiceEntry" to "Invoice issued",
        "pdfEarnedFromWork" to "Earned (work done)",
        "pdfGivenUnitValue" to "Value of units given",
        "pdfCashPaidTotal" to "Cash paid",
        "pdfCraftsmanOwedText" to "You owe {amount}",
        "pdfCraftsmanOwesText" to "Owes you {amount}",
        "pdfAccountBalanced" to "Account settled",
        "pdfStatement" to "Account Statement",
        "pdfBalance" to "Balance",
        "pdfPurchase" to "Debit",
        "pdfPayment" to "Payment",
        "pdfSale" to "Sale",
        "pdfCollection" to "Collection",
        "pdfTotalPurchases" to "Total Purchases",
        "pdfTotalPayments" to "Total Payments",
        "pdfTotalSales" to "Total Sales",
        "pdfTotalCollections" to "Total Collections",
        "pdfCurrentReceivable" to "Current Receivable",
        "pdfCurrentDebt" to "Current Payable",
        "dateLabel" to "Date",
        "amountFieldLabel" to "Amount",
        "enterValidAmount" to "Enter a valid amount.",
        "completed" to "Completed",
        "deleteCraftsmanAction" to "Delete craftsman",
        "updateWork" to "Update Work",
        "giveUnitAction" to "Give Unit",
        "entryAction" to "Entry",
        "givenUnitsSection" to "Units Given",
        "accountEntriesSection" to "Account Entries",
        "noEntriesYet" to "No entries yet.\nUse \"Entry\" to add extra work/material or a cash payment.",
        "takeBackUnitTitle" to "Take Unit Back",
        "takeBackUnitMessage" to "Remove {unit} from the barter and mark it available again?",
        "takeBack" to "Take Back",
        "deleteEntryTitle" to "Delete Entry",
        "deleteEntryMessage" to "Delete {desc} ({amount})?",
        "deleteCraftsmanTitle" to "Delete Craftsman",
        "deleteCraftsmanMessage" to "\"{name}\" and all account entries will be deleted. Units already given stay sold. Are you sure?",
        "craftsmanOwedTitle" to "You Owe the Craftsman",
        "craftsmanOwesTitle" to "Craftsman Owes You",
        "accountBalancedTitle" to "Account Settled",
        "agreementTotal" to "Agreement total: {amount}",
        "doneRemaining" to "Done: {done} • Left: {remaining} {units}",
        "earnedFromWorkLine" to "Earned (work done)",
        "extraWorkLine" to "Extra work / material",
        "givenUnitValueLine" to "Value of units given",
        "cashPaidLine" to "Cash paid",
        "whenFinishedLine" to "When finished",
        "whenFinishedOwed" to "You will owe {amount}",
        "whenFinishedOwes" to "Craftsman will owe {amount}",
        "whenFinishedBalanced" to "The account will close even",
        "givenAsBarter" to "Given as barter",
        "invoiceCardTitle" to "Invoice Required",
        "invoiceRemainingShort" to "{amount} left",
        "invoiceIssuedOf" to "Issued: {invoiced} / {required}",
        "invoiceCardHint" to "Tap to set the invoice amount you require. Issued invoices are added via \"Entry → Invoice\".",
        "invoiceDialogTitle" to "Required Invoice Amount",
        "invoiceDialogHint" to "Total invoice amount required from this craftsman. Enter zero to turn invoice tracking off.",
        "updateWorkTitle" to "Update Work Done",
        "updateWorkHint" to "Enter the completed counts per apartment type. You can lower them again if you mistype.",
        "workTypeAgreedLabel" to "{type} — agreed {count}",
        "entryTypeCash" to "Cash",
        "entryTypeExtra" to "Extra Work",
        "entryTypeInvoice" to "Invoice",
        "entryCashTitle" to "Cash Payment",
        "entryExtraTitle" to "Extra Work / Material",
        "entryInvoiceTitle" to "Invoice Issued",
        "descCashHint" to "Description (e.g. advance)",
        "descExtraHint" to "Description (e.g. basement wiring, cable)",
        "descInvoiceHint" to "Description (e.g. invoice no.)",
        "hintCashPayment" to "Deducted from what you owe the craftsman. No cash entry is created — add one from Transactions if needed.",
        "hintExtraWork" to "Added to what you owe the craftsman (work or material outside the agreement).",
        "hintInvoice" to "Added to the issued-invoice total; it does not affect the balance.",
        "giveUnitTitle" to "Give a Unit as Barter",
        "giveUnitHint" to "The unit becomes sold but creates no cash income; its value is deducted from the craftsman's balance.",
        "unitValueLabel" to "Unit Value",
        "give" to "Give",
        "selectUnitError" to "Select a unit.",
        "enterUnitValueError" to "Enter the unit value.",
        "unitLabel" to "Unit",
        "importing" to "Importing…",
        "importDoneTitle" to "Import Complete",
        "importDoneMessage" to "{count} transactions added.",
        "importFailedTitle" to "Import Failed",
        "importPreviewTitle" to "Import Preview",
        "importIncomeRows" to "Income rows",
        "importExpenseRows" to "Expense rows",
        "importHouseRows" to "Household expense (within expenses)",
        "importSkippedSales" to "Unit sales (skipped)",
        "importRowCount" to "{count} rows",
        "importTargetProject" to "All rows will be added to \"{project}\".",
        "importUnknownProjects" to "Unmatched projects (rows imported without a project): ",
        "importSkippedRows" to "Skipped rows ({count}):",
        "importAction" to "Import",
        "importNoRows" to "No importable rows found. Column order: Date, Type (GELİR/GİDER/EV GİDER), Category, Description, Project, Amount.",
        "importSalesSkippedNote" to "Unit-sale rows are not imported ({count} rows).",
        "importFailedMessage" to "Import failed: {error}",
        "unknownError" to "unknown error",
        "projectNameLabel" to "Project Name",
        "locationLabel" to "Location",
        "startLabel" to "Start",
        "estimatedEndLabel" to "Estimated End",
        "floorCountLabel" to "Number of Floors",
        "unitsPerFloorLabel" to "Units per Floor",
        "coverColorLabel" to "Card Color",
        "createProject" to "Create Project",
        "errorProjectName" to "Enter a project name.",
        "errorFloors" to "Floors must be between 1 and 60.",
        "errorUnitsPerFloor" to "Units per floor must be between 1 and 12.",
        "newTransaction" to "New Transaction",
        "editTransaction" to "Edit Transaction",
        "incomeType" to "Income Type",
        "expenseCategory" to "Expense Category",
        "descriptionOptional" to "Description (optional)",
        "soldUnitLabel" to "Sold Unit",
        "errorSelectIncomeType" to "Select an income type.",
        "errorSelectExpenseCategory" to "Select an expense category.",
        "errorSelectProjectForSale" to "Select a project for the unit sale.",
        "errorSelectSoldUnit" to "Select the sold unit.",
        "errorEnterDescription" to "Enter a description.",
        "noUnitsAvailable" to "No units left for sale in this project.",
        "noUnitsDefined" to "No units defined for this project.",
        "saleMarksUnit" to "On save, the selected unit is marked sold in the project.",
        "deleteProjectAction" to "Delete project",
        "buildingLabel" to "Building",
        "buildingValue" to "{floors} floors • {perFloor} units per floor",
        "constructionStatus" to "Construction Status",
        "progressLabel" to "Progress",
        "showStages" to "Show stages",
        "completedCheck" to "Completed ✓",
        "completedParty" to "Completed 🎉",
        "buyersSection" to "Buyers",
        "projectTransactionsSection" to "Project Transactions",
        "noProjectTransactions" to "No transactions linked to this project.",
        "deleteProjectTitle" to "Delete Project",
        "deleteProjectMessage" to "\"{name}\" and all its unit records will be permanently deleted. Monthly income/expense entries stay in the accounting history. Are you sure?",
        "barterUnitSubtitle" to "Floor {floor} • Barter",
        "floorShort" to "Floor {floor}",
        "statusSold" to "Sold",
        "statusReserved" to "Reserved",
        "statusAvailable" to "Available",
        "barterShort" to "Barter",
        "salePriceLabel" to "Sale Price",
        "saleDateLabel" to "Sale Date",
        "buyerNameLabel" to "Buyer Name",
        "buyerPhoneLabel" to "Buyer Phone (optional)",
        "paymentsReceived" to "Payments Received",
        "addPayment" to "+ Add Payment",
        "deletePayment" to "Delete payment",
        "remainingDebt" to "Remaining",
        "fullyPaid" to "Fully paid ✓",
        "paidAmount" to "Paid {amount}",
        "errorSalePrice" to "Enter the sale price.",
        "noBuyerGiven" to "No buyer given",
        "barterInfo" to "{unit} was given as barter. Account details (earnings, payments) are on the Craftsmen page.",
        "saleSummary" to "{unit} • Sale {amount}",
        "deleteAccountAction" to "Delete account",
        "printPdf" to "Print as PDF",
        "materialPurchase" to "Purchase",
        "materialSale" to "Sale",
        "paymentOrCarry" to "Payment / Carry-over",
        "collectionOrCarry" to "Collection / Carry-over",
        "noEntriesSupplier" to "No entries yet.\nRecord purchases, payments and any carried-over debt here.",
        "noEntriesCustomer" to "No entries yet.\nRecord sales, collections and any carried-over receivable here.",
        "purchasePrefix" to "Purchase",
        "salePrefix" to "Sale",
        "deleteRecordTitle" to "Delete Record",
        "thisRecord" to "This record",
        "deleteRecordMessage" to "Delete {desc} ({amount})?",
        "deleteCustomerTitle" to "Delete Customer",
        "deleteSupplierTitle" to "Delete Supplier",
        "deleteAccountMessage" to "\"{name}\" and all account entries will be permanently deleted. Are you sure?",
        "materialSaleEntry" to "Material sale",
        "materialPurchaseEntry" to "Material purchase",
        "makePayment" to "Make Payment",
        "addCarryReceivable" to "Add Carried Receivable",
        "addCarryDebt" to "Add Carried Debt",
        "carryReceivable" to "Carried Receivable",
        "carryDebt" to "Carried Debt",
        "descPaymentHint" to "Description (cash, card, cheque…)",
        "descCarryHint" to "Description (e.g. carried from old account)",
        "hintCarryReceivable" to "The carried receivable is added to the balance; new sales build on top of it.",
        "hintCarryDebt" to "The carried debt is added to the balance; new purchases build on top of it.",
        "editPurchase" to "Edit Purchase",
        "editSale" to "Edit Sale",
        "itemNameLabel" to "Item / Name",
        "deleteRow" to "Delete row",
        "rowTotal" to "Row total: {amount}",
        "errorAtLeastOneItem" to "Add at least one item row.",
        "errorIncompleteRow" to "Incomplete row: name, quantity and unit price are required.",
        "errorEnterReceiver" to "Enter who received it.",
        "kurusLabel" to ".00",
        "blockWord" to "Block",
        "buildingStatus" to "Building Status",
        "blockSummary" to "{sold}/{total} sold",
        "pdfBlock" to "Block",
        "blocksSection" to "Blocks",
        "blocksHint" to "Each block can have its own floors and units per floor. Leave as is if one block is enough.",
        "addBlock" to "+ Add Block",
        "removeBlock" to "Remove block",
        "blockNameLabel" to "Block Name",
        "errorBlockLayout" to "Enter floors (1-60) and units per floor (1-12) for every block.",
        "blockLayoutSummary" to "{floors} floors × {perFloor} units",
        "pdfBlocks" to "Blocks",
        "addToDailyLedger" to "Add to the cash ledger",
        "addToDailyLedgerHintOn" to "The entry appears in the monthly cash reports.",
        "addToDailyLedgerHintOff" to "The entry is recorded on the project only; it stays out of the monthly cash ledger (Home, Transactions, Reports).",
        "errorProjectRequiredOffLedger" to "Select a project for an entry kept out of the cash ledger.",
        "projectOnlyBadge" to "Project only",
    ),
)
